<template>
  <NuxtLink
    :to="props.to"
    class="level-nav__link"
    :class="{ 'prepeers-nav-link--active': props.active }"
    :aria-current="props.active ? 'page' : undefined">
    <slot />
  </NuxtLink>
</template>

<script setup lang="ts">
import type { PropType } from 'vue'
import type { RouteLocationRaw } from 'vue-router'
import type { PrePeersNavLinkProps } from '~/types/PrePeersNavLink'

/**
 * Définit les props du composant PrePeersNavLink.
 */
const props: PrePeersNavLinkProps = defineProps({
  to: {
    type: [String, Object] as PropType<RouteLocationRaw>,
    required: true,
  },
  active: {
    type: Boolean,
    default: false,
  },
})
</script>

<style scoped>
.prepeers-nav-link--active {
  border-color: var(--accent-blue) !important;
  background-color: rgba(3, 160, 241, 0.18) !important;
  color: var(--accent-blue-lt) !important;
  box-shadow: 0 0 0 1px rgba(3, 160, 241, 0.35);
}
</style>
